/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ChevronLeftIcon = props => {
	const { color = '' } = props
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 9.333 16.326'>
			<path
				data-name='Icon ionic-ios-arrow-back'
				d='M2.813 8.16L8.99 1.988A1.167 1.167 0 007.338.34l-7 6.994a1.164 1.164 0 00-.034 1.609l7.028 7.042a1.167 1.167 0 101.652-1.648z'
				fill={color}
			/>
		</svg>
	)
}

export default ChevronLeftIcon
